export const calculateOptionWiseScore = (data) => {
  if (data && data.numberOfOptions && data.score) {
    let totalScore = data.score.reduce((partialSum, a) => +partialSum + +a, 0);
    return (+totalScore / +data.numberOfOptions).toFixed(2);
  } else {
    return 0;
  }
};

export const calculateGenericScore = (currentAttempt, numberOfAttemptes, score) => {
    let weightage = ((+numberOfAttemptes)-(+currentAttempt-1))/numberOfAttemptes;
    return score * weightage;
}